export default __webpack_public_path__ + "static/media/settings.67942ea7.svg";